/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.service.analysis
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: analysis_availability.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as analysis_availability_pb from './analysis_availability_pb'; // proto import: "analysis_availability.proto"


export class ArchitecturalPlanAnalysisServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetAvailableAnalysis = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.analysis.ArchitecturalPlanAnalysisService/GetAvailableAnalysis',
    grpcWeb.MethodType.UNARY,
    analysis_availability_pb.GetAvailableAnalysisRequest,
    analysis_availability_pb.GetAvailableAnalysisResponse,
    (request: analysis_availability_pb.GetAvailableAnalysisRequest) => {
      return request.serializeBinary();
    },
    analysis_availability_pb.GetAvailableAnalysisResponse.deserializeBinary
  );

  getAvailableAnalysis(
    request: analysis_availability_pb.GetAvailableAnalysisRequest,
    metadata?: grpcWeb.Metadata | null): Promise<analysis_availability_pb.GetAvailableAnalysisResponse>;

  getAvailableAnalysis(
    request: analysis_availability_pb.GetAvailableAnalysisRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: analysis_availability_pb.GetAvailableAnalysisResponse) => void): grpcWeb.ClientReadableStream<analysis_availability_pb.GetAvailableAnalysisResponse>;

  getAvailableAnalysis(
    request: analysis_availability_pb.GetAvailableAnalysisRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: analysis_availability_pb.GetAvailableAnalysisResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.analysis.ArchitecturalPlanAnalysisService/GetAvailableAnalysis',
        request,
        metadata || {},
        this.methodDescriptorGetAvailableAnalysis,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.analysis.ArchitecturalPlanAnalysisService/GetAvailableAnalysis',
    request,
    metadata || {},
    this.methodDescriptorGetAvailableAnalysis);
  }

  methodDescriptorGetAvailableAnalysisForProject = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.analysis.ArchitecturalPlanAnalysisService/GetAvailableAnalysisForProject',
    grpcWeb.MethodType.UNARY,
    analysis_availability_pb.GetAvailableAnalysisForProjectRequest,
    analysis_availability_pb.GetAvailableAnalysisForProjectResponse,
    (request: analysis_availability_pb.GetAvailableAnalysisForProjectRequest) => {
      return request.serializeBinary();
    },
    analysis_availability_pb.GetAvailableAnalysisForProjectResponse.deserializeBinary
  );

  getAvailableAnalysisForProject(
    request: analysis_availability_pb.GetAvailableAnalysisForProjectRequest,
    metadata?: grpcWeb.Metadata | null): Promise<analysis_availability_pb.GetAvailableAnalysisForProjectResponse>;

  getAvailableAnalysisForProject(
    request: analysis_availability_pb.GetAvailableAnalysisForProjectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: analysis_availability_pb.GetAvailableAnalysisForProjectResponse) => void): grpcWeb.ClientReadableStream<analysis_availability_pb.GetAvailableAnalysisForProjectResponse>;

  getAvailableAnalysisForProject(
    request: analysis_availability_pb.GetAvailableAnalysisForProjectRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: analysis_availability_pb.GetAvailableAnalysisForProjectResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.analysis.ArchitecturalPlanAnalysisService/GetAvailableAnalysisForProject',
        request,
        metadata || {},
        this.methodDescriptorGetAvailableAnalysisForProject,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.analysis.ArchitecturalPlanAnalysisService/GetAvailableAnalysisForProject',
    request,
    metadata || {},
    this.methodDescriptorGetAvailableAnalysisForProject);
  }

}

